import type { PlayerBonus, PlayerFreespin } from 'api/common';
import { BonusStage } from 'api/common';
import {
  isSilentWagerFreeCash,
  isWagerFreeActivatedCash,
} from 'modules/bonuses/helpers/wagerFreeCash';

export const UNSEEN_BONUS_STAGES: BonusStage[] = [
  BonusStage.Issued,
  BonusStage.HandleBets,
];

export const isUnseenBonus = (
  bonus: PlayerBonus | PlayerFreespin,
  lastSeenTime: number
) =>
  UNSEEN_BONUS_STAGES.includes(bonus.stage) &&
  !isSilentWagerFreeCash(bonus) &&
  new Date(bonus.createdAt).getTime() > lastSeenTime;

const isNewlyIssuedBonus = (
  bonus: PlayerBonus | PlayerFreespin,
  previousBonus?: PlayerBonus | PlayerFreespin
) =>
  !previousBonus &&
  UNSEEN_BONUS_STAGES.includes(bonus.stage) &&
  !isSilentWagerFreeCash(bonus);

const hasBecomeWagerFreeActivatedCash = (
  bonus: PlayerBonus | PlayerFreespin,
  previousBonus?: PlayerBonus | PlayerFreespin
) =>
  isWagerFreeActivatedCash(bonus) &&
  !(previousBonus && isWagerFreeActivatedCash(previousBonus));

export const isReceivedBonus = (
  bonus: PlayerBonus | PlayerFreespin,
  previousBonus?: PlayerBonus | PlayerFreespin
) =>
  isNewlyIssuedBonus(bonus, previousBonus) ||
  hasBecomeWagerFreeActivatedCash(bonus, previousBonus);
